import { addStyles } from 'ethcss'
import { grid, IStyles } from 'theme'

export const checkboxStyles: IStyles = {
    wrapper: {
        ...grid.iBlock
    }
}

addStyles(checkboxStyles)
